<!-- Welcome -->
<div class="welcome-card">
    <div>
        <h2 style="font-weight: normal;">Welcome Back, <span style="font-weight: 600;">{{user.name}}</span>
            ({{user.position}})</h2>
        <p>Manage your classes, students, attendance and assignments efficiently.</p>
    </div>

    <button class="btn btn-primary">
        <i class="bi bi-plus-circle"></i>
        Create Assignment
    </button>
</div>

<!-- Statistics -->
<div class="row g-3 mt-1">
    <div class="col-lg-3 col-md-6">
        <div class="stat-card">

            <div class="stat-icon bg-primary-subtle text-primary">
                <i class="bi bi-people"></i>
            </div>

            <div>
                <h3>1,245</h3>
                <p>Total Students</p>
            </div>

        </div>
    </div>

    <div class="col-lg-3 col-md-6">
        <div class="stat-card">

            <div class="stat-icon bg-success-subtle text-success">
                <i class="bi bi-journal-check"></i>
            </div>

            <div>
                <h3>32</h3>
                <p>Classes</p>
            </div>

        </div>
    </div>

    <div class="col-lg-3 col-md-6">
        <div class="stat-card">

            <div class="stat-icon bg-warning-subtle text-warning">
                <i class="bi bi-file-earmark-text"></i>
            </div>

            <div>
                <h3>18</h3>
                <p>Assignments</p>
            </div>

        </div>
    </div>

    <div class="col-lg-3 col-md-6">
        <div class="stat-card">

            <div class="stat-icon bg-danger-subtle text-danger">
                <i class="bi bi-calendar-check"></i>
            </div>

            <div>
                <h3>92%</h3>
                <p>Attendance</p>
            </div>

        </div>
    </div>
</div>

<div class="row g-3 mt-1">
    <!-- Timetable -->
    <div class="col-lg-4">
        <div class="tdashboard-card h-100">
            <div class="card-header-custom">
                <h5>Today's Schedule</h5>
                <button class="btn btn-sm btn-light">
                    Full Timetable
                </button>
            </div>

            <div class="schedule-list">
                <div class="schedule-item active-class">
                    <div class="schedule-time">
                        09:00
                    </div>

                    <div class="schedule-content">
                        <h6>Mathematics</h6>
                        <p>Class 10-A | Room 204</p>
                    </div>

                    <span class="badge bg-success">
                        Live
                    </span>
                </div>

                <div class="schedule-item">
                    <div class="schedule-time">
                        11:00
                    </div>

                    <div class="schedule-content">
                        <h6>Physics</h6>
                        <p>Class 11-B | Room 106</p>
                    </div>
                </div>

                <div class="schedule-item">
                    <div class="schedule-time">
                        01:30
                    </div>

                    <div class="schedule-content">
                        <h6>Chemistry</h6>
                        <p>Class 12-A | Lab 2</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- Quick Actions -->
    <div class="col-lg-4">
        <div class="tdashboard-card h-100">
            <div class="card-header-custom">
                <h5>Quick Actions</h5>
            </div>

            <div class="quick-actions">
                <a href="#" class="quick-action-box">
                    <i class="bi bi-person-check"></i>
                    <span>Take Attendance</span>
                </a>

                <a href="#" class="quick-action-box">
                    <i class="bi bi-upload"></i>
                    <span>Upload Notes</span>
                </a>

                <a href="#" class="quick-action-box">
                    <i class="bi bi-file-earmark-plus"></i>
                    <span>Create Exam</span>
                </a>

                <a href="#" class="quick-action-box">
                    <i class="bi bi-journal-text"></i>
                    <span>Add Homework</span>
                </a>

                <a href="#" class="quick-action-box">
                    <i class="bi bi-chat-square-dots"></i>
                    <span>Parent Chat</span>
                </a>

                <a href="#" class="quick-action-box">
                    <i class="bi bi-cloud-arrow-up"></i>
                    <span>Upload Marks</span>
                </a>

            </div>
        </div>
    </div>

    <!-- Performance -->
    <div class="col-lg-4">
        <div class="tdashboard-card h-100">
            <div class="card-header-custom">
                <h5>Class Performance</h5>
            </div>

            <div class="performance-box">
                <div class="performance-item">
                    <div>
                        <h6>Class 10-A</h6>
                        <p>Average Result</p>
                    </div>

                    <h5 class="text-success">89%</h5>
                </div>

                <div class="progress mb-4">
                    <div class="progress-bar bg-success" style="width:89%"></div>
                </div>

                <div class="performance-item">
                    <div>
                        <h6>Class 11-B</h6>
                        <p>Average Result</p>
                    </div>

                    <h5 class="text-primary">78%</h5>
                </div>

                <div class="progress mb-4">
                    <div class="progress-bar bg-primary" style="width:78%"></div>
                </div>

                <div class="performance-item">
                    <div>
                        <h6>Class 12-A</h6>
                        <p>Average Result</p>
                    </div>

                    <h5 class="text-warning">71%</h5>
                </div>

                <div class="progress">
                    <div class="progress-bar bg-warning" style="width:71%"></div>
                </div>

            </div>
        </div>
    </div>

</div>

<div class="row g-3 mt-1">
    <!-- Recent Assignments -->
    <div class="col-lg-6">
        <div class="tdashboard-card">
            <div class="card-header-custom">
                <h5>Recent Assignments</h5>

                <button class="btn btn-sm btn-primary">
                    New Assignment
                </button>
            </div>

            <div class="assignment-list">
                <div class="assignment-item">
                    <div class="assignment-icon bg-primary-subtle text-primary">
                        <i class="bi bi-file-earmark-text"></i>
                    </div>

                    <div class="flex-grow-1">
                        <h6>Algebra Worksheet</h6>
                        <p>Class 10-A</p>
                    </div>

                    <span class="badge bg-warning text-dark">
                        Pending Review
                    </span>
                </div>

                <div class="assignment-item">
                    <div class="assignment-icon bg-success-subtle text-success">
                        <i class="bi bi-check-circle"></i>
                    </div>

                    <div class="flex-grow-1">
                        <h6>Physics Practical</h6>
                        <p>Class 11-B</p>
                    </div>

                    <span class="badge bg-success">
                        Completed
                    </span>
                </div>

                <div class="assignment-item">
                    <div class="assignment-icon bg-danger-subtle text-danger">
                        <i class="bi bi-clock-history"></i>
                    </div>

                    <div class="flex-grow-1">
                        <h6>Chemistry Notes</h6>
                        <p>Class 12-A</p>
                    </div>

                    <span class="badge bg-danger">
                        Overdue
                    </span>
                </div>
            </div>
        </div>
    </div>

    <!-- Student Activity -->
    <div class="col-lg-6">
        <div class="tdashboard-card">
            <div class="card-header-custom">
                <h5>Student Activity</h5>
            </div>

            <div class="activity-list">
                <div class="activity-item">
                    <div class="activity-avatar bg-primary">
                        AK
                    </div>

                    <div class="flex-grow-1">
                        <h6>Arjun Kumar</h6>
                        <p>Submitted Mathematics Assignment</p>
                    </div>

                    <small>5 min ago</small>
                </div>

                <div class="activity-item">
                    <div class="activity-avatar bg-success">
                        RS
                    </div>

                    <div class="flex-grow-1">
                        <h6>Riya Sharma</h6>
                        <p>Attendance marked present</p>
                    </div>

                    <small>20 min ago</small>
                </div>

                <div class="activity-item">
                    <div class="activity-avatar bg-warning text-dark">
                        VK
                    </div>

                    <div class="flex-grow-1">
                        <h6>Vikas Kumar</h6>
                        <p>Requested assignment extension</p>
                    </div>

                    <small>1 hour ago</small>
                </div>

                <div class="activity-item">
                    <div class="activity-avatar bg-danger">
                        AM
                    </div>

                    <div class="flex-grow-1">
                        <h6>Anjali Mehta</h6>
                        <p>Scored 98% in Physics Test</p>
                    </div>

                    <small>2 hours ago</small>
                </div>
            </div>
        </div>
    </div>
</div>